import crypto from "crypto";

export function sha1(str: string, limit?: number) {
  const shasum = crypto.createHash("sha1");
  shasum.update(str);
  let r = shasum.digest("hex");
  if (limit) r = r.slice(0, limit);
  return r;
}
